var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCheckCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1 4.9C17.2 3.1 14.7 2 12 2 6.5 2 2 6.5 2 12s4.5 10 10 10 10-4.5 10-10c0-2.7-1.1-5.2-2.9-7.1zM16.5 10L12 14.8c-.2.2-.3.2-.5.2s-.3-.1-.4-.2l-2.7-2.4c-.2-.2-.3-.4-.2-.6 0-.2.2-.4.4-.5.2-.1.5 0 .6.1l2.2 2 4.1-4.3c.2-.1.4-.2.7-.1.2.1.4.2.5.4 0 .2-.1.5-.2.6z"
  })));
}

export default SvgCheckCircle;